export const navigation = {
  support: {
    question: "¿Necesitas asistencia?",
    whatsappCta: "Escríbenos por WhatsApp",
  },
  alt: {
    whatsapp: "Icono de WhatsApp",
    logo: "Logo del panel",
  },
};